import { useEffect, useRef, useState } from 'react'
import { useMediaQuery } from '@/hooks/useMediaQuery'

/** The end marker follows streamed text, edited answers and viewport changes. */
export function useThreadPosition() {
  const thread = useRef<HTMLElement>(null)
  const end = useRef<HTMLDivElement>(null)
  const [away, setAway] = useState(false)
  const reduced = useMediaQuery('(prefers-reduced-motion: reduce)')
  useEffect(() => {
    if (!thread.current || !end.current) return
    const observer = new IntersectionObserver(([entry]) => setAway(!entry.isIntersecting), { root: thread.current, threshold: 0 })
    observer.observe(end.current)
    return () => observer.disconnect()
  }, [])
  function latest() { thread.current?.scrollTo({ top: thread.current.scrollHeight, behavior: reduced ? 'instant' : 'smooth' }) }
  return { thread, end, away, latest }
}
